import { LoggedInUser } from "models";
import { RecoilAtoms } from "../config/recoil-atoms";
import { atom } from "recoil";

export const loggedInUserAtom = atom<LoggedInUser | null>({
  key: RecoilAtoms.LOGGED_IN_USER,
  default: null,
});
